import type { TokenId, Vault } from 'nftx.js';
import { useTranslations } from 'use-intl';
import AssetImage from '@/presentation/components/elements/AssetImage';
import Icon, { Icons } from '../../../elements/Icon';

export default function Erc721Input({
  tokenIds,
  vault,
  canChangeToken,
  onSearchClick,
  onRemoveItem,
}: {
  tokenIds: `${number}`[] | undefined;
  vault: Pick<Vault, 'asset' | 'token' | 'tokenId'> | undefined;
  canChangeToken: boolean;
  onSearchClick: () => void;
  onRemoveItem: (tokenId: TokenId) => void;
}) {
  const t = useTranslations('Swap');

  if (!vault || !tokenIds) {
    return (
      <button
        type="button"
        className="py-2 px-2 flex items-center text-sm uppercase font-bold border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-100 rounded-lg text-gray-800"
        onClick={() => canChangeToken && onSearchClick()}
      >
        {t('empty')}
      </button>
    );
  }

  return (
    <div className="flex justify-between items-start">
      <button
        type="button"
        className="py-2 px-2 flex items-center text-sm uppercase font-bold border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-100 rounded-lg text-gray-800 overflow-hidden"
        onClick={() => canChangeToken && onSearchClick()}
      >
        <div className="flex gap-2 items-center overflow-hidden">
          <AssetImage
            assetAddress={vault.asset.id}
            tokenId={vault.tokenId}
            className="w-5 h-5 flex-none"
          />
          <span className="truncate">{vault.token.name}</span>
          {canChangeToken && (
            <Icon
              name={Icons.CHEVRON_DOWN}
              size={12}
              className="ml-2 flex-none"
            />
          )}
        </div>
      </button>
      <ul className="flex items-center flex-wrap justify-end py-1 pl-2 gap-1.5">
        {tokenIds.map((tokenId) => (
          <li
            key={tokenId}
            className="rounded-sm overflow-hidden"
            role="button"
            onClick={() => onRemoveItem(tokenId)}
          >
            <AssetImage
              assetAddress={vault.asset.id}
              tokenId={tokenId}
              className="w-8 h-8"
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
